import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

export default function FormWrapper(props) {
     
    return ( 
        <>
        {props?.withCard === true ? (             
            <Card sx={{ maxWidth: '1000px' }}>
                <CardContent>
                    {props?.children}
                </CardContent>
            </Card>
        ) : ( 
            <>
                {props?.children}
            </>
        )}
        </>
    )
    
}